import { z } from 'zod'

/**
 * The two ways a period's lead stats are read (docs/gohighlevel-stats.spec.md).
 *
 * - `cohort`: what became of the leads that arrived in the period.
 * - `activity`: what happened during the period, whenever those leads arrived.
 *
 * Appointments count by their own dates in both: the tours booked in a period,
 * whoever booked them.
 */
export const LEAD_STATS_VIEWS = ['cohort', 'activity'] as const

export const leadStatsViewSchema = z.enum(LEAD_STATS_VIEWS)

export type LeadStatsView = z.infer<typeof leadStatsViewSchema>
